import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { RoleGuard } from './role.guard';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
  {
    path: "pages",
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
    data: {
      roles: [
        "Admin",
        "Agent",
        "MenuMaker",
        "OnlineOperationAgent",
        "CateringManager",
        "DonationManager",
        "ITSupport",
        "StoreActivationManager",
        "ItemShowHideOperations",
      ],
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: "call-center",
    loadChildren: () =>
      import("./call-center/call-center.module").then(
        (m) => m.CallCenterModule
      ),
    data: {
      roles: ["Admin", "Agent"],
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: "donations",
    loadChildren: () =>
      import("./donations/donations.module").then((m) => m.DonationsModule),
    data: {
      roles: ["Admin", "CateringManager", "DonationManager"],
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: "all-orders",
    loadChildren: () =>
      import("./all-orders/all-orders.module").then((m) => m.AllOrdersModule),
    data: {
      roles: ["Admin", "MenuMaker", "OnlineOperationAgent", "ITSupport"],
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: "menu-builder",
    loadChildren: () =>
      import("./menu-maker-ext/menu-maker-ext.module").then(
        (m) => m.MenuMakerExtModule
      ),
    data: {
      roles: [
        "Admin",
        "MenuMaker",
        "OnlineOperationAgent",
        "StoreActivationManager",
        "ItemShowHideOperations",
      ],
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  {
    path: "template",
    loadChildren: () =>
      import("./template/template.module").then((m) => m.TemplateModule),
    data: {
      roles: ["Admin"],
    },
    canActivate: [MsalGuard, RoleGuard],
  },
  { path: "", component: HomeComponent },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
